import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import workspace from "../../../canvas/core/workspace";
import {inchesToMm} from "../../../../helpers/sqftHelper";
import {POINT_PROPERTY} from "../../../../constants";

const SqftSummaryAngles = (props) => {
  const {measureUnit} = props;
  const angles = workspace.getPointProperty(POINT_PROPERTY.angle);

  let anglesCount = [],
    angleDisplayName;

  angles.forEach(function(x) { anglesCount[x.value] = (anglesCount[x.value] || 0) + 1; });

  return (
    anglesCount.map((anglesValue, angleName) => {
      angleDisplayName = measureUnit === "Imperial" ? angleName + "\"" : inchesToMm(angleName) + 'mm';

      return (
        <div className="summary-list__item summary summary--purple" key={angleName}>
          <div className="summary-title">{"45°" + angleDisplayName}</div>
          <div className="summary-info">
            <div className="summary-info__left">
              <FormattedMessage id="sqft.navigation.summary.amount"/>
              : { anglesValue }
            </div>
          </div>
        </div>
      )
    })
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  activeButton: store.sqftMenuState.activeButton,
  measureUnit: store.sqftState.measureUnit
});

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(SqftSummaryAngles);
